module.exports = __webpack_public_path__ + "static/media/ic_robotrader_about_two.8617db0e.svg";